import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { DOCUMENT_BUNDLES_ACTION_TYPE } from '../actions';

const initialState = {};

const documentBundles = (state = initialState, { type, payload, meta }) =>
  produce(state, draft => {
    switch (type) {
      case DOCUMENT_BUNDLES_ACTION_TYPE.GET_DOCUMENT_BUNDLES:
        return payload;

      case DOCUMENT_BUNDLES_ACTION_TYPE.CREATE_DOCUMENT_BUNDLE:
      case DOCUMENT_BUNDLES_ACTION_TYPE.EDIT_DOCUMENT_BUNDLE:
        draft[payload.documentBundleTypeId] = payload;
        break;

      case DOCUMENT_BUNDLES_ACTION_TYPE.DELETE_DOCUMENT_BUNDLE:
        delete draft[meta.id];
        break;

      case DOCUMENT_BUNDLES_ACTION_TYPE.REORDER_DOCUMENT_TYPES_IN_BUNDLE:
        payload.documentTypeIds.forEach(
          (typeId, index) =>
            (draft[payload.documentBundleId].documentBundleDocumentTypes[typeId].orderNumber =
              index),
        );
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default documentBundles;
